import { useAuth0 } from "@auth0/auth0-react";
import { Navigate } from "react-router-dom";

export default function RequireAuth({ children }) {
  const { isAuthenticated, isLoading } = useAuth0();

  // ✅ WAIT FOR AUTH0
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p>Loading authentication...</p>
      </div>
    );
  }

  // 🔐 NOT LOGGED IN
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // ✅ AUTHENTICATED
  return children;
}
